import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom'
import { Layout } from '../components/Layout/Layout'
import Dashboard from '../pages/Dashboard'
import Settings from '../pages/Settings'
import Trading from '../pages/Trading'
import Assets from '@/pages/Assets'
import Registration from '@/pages/Registration'
import Send from '@/pages/Send'
import Receive from '@/pages/Receive'
import AuthGuard from '@/components/auth/AuthGuard'
import TransactionHistory from '@/pages/TransactionHistory'
import Welcome from '@/pages/Welcome'
import RecoverWallet from '@/pages/RecoverWallet'
import Airdrops from '@/pages/Airdrops'
import AssetDetails from '@/pages/AssetDetails'
import Networks from '@/pages/Networks'
import AddNetwork from '@/pages/AddNetwork'
import NetworkDetails from '@/pages/NetworkDetails'
import Wallets from '@/pages/Wallets'
import AddWallet from '@/pages/AddWallet'
import ResetWallet from '@/pages/ResetWallet'
import Explorer from '@/pages/Explorer'
import ComingSoon from '@/pages/ComingSoon'
import Swap from '@/pages/Swap'
import { isSwapEnabled } from '@/config/app'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Welcome />
      },
      {
        path: 'reset-wallet',
        element: <ResetWallet />
      },
      {
        path: 'coming-soon',
        element: <ComingSoon />
      },

      // Registration uses Layout (for the Header) but not AuthGuard,
      // since a new user has no wallet unlocked yet.
      {
        element: <Layout />,
        children: [
          {
            path: 'registration',
            element: <Registration />
          }
        ]
      },
      // Routes with Layout protected by AuthGuard
      {
        element: (
          <AuthGuard>
            <Layout />
          </AuthGuard>
        ),
        children: [
          {
            path: 'dashboard',
            element: <Dashboard />
          },
          {
            path: 'trading',
            element: <Trading />
          },
          {
            path: 'send',
            element: <Send />
          },
          {
            path: 'receive',
            element: <Receive />
          },
          {
            path: 'settings',
            element: <Settings />
          },
          {
            path: 'explorer',
            element: <Explorer />
          },
          { path: 'assets', element: <Assets /> },
          { path: 'history', element: <TransactionHistory /> },
          { path: 'recover', element: <RecoverWallet /> },
          { path: 'airdrops', element: <Airdrops /> },
          { path: 'asset-details/:code', element: <AssetDetails /> },
          { path: 'networks', element: <Networks /> },
          { path: 'add-network', element: <AddNetwork /> },
          { path: 'network-details/:id', element: <NetworkDetails /> },
          { path: 'wallets', element: <Wallets /> },
          { path: 'add-wallet', element: <AddWallet /> },
          {
            path: 'swap',
            element: isSwapEnabled() ? <Swap /> : <Navigate to="/dashboard" replace />
          }
        ]
      }
    ]
  }
])
